import { render } from "./toCreate.vue?vue&type=template&id=868ba378&scoped=true"
import script from "./toCreate.vue?vue&type=script&lang=js"
export * from "./toCreate.vue?vue&type=script&lang=js"

import "./toCreate.vue?vue&type=style&index=0&id=868ba378&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-868ba378"]])

export default __exports__